export default {
  props: {
    list: {
      type: Array,
      default() {
        return [];
      }
    },
    scheduleInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    goInfoFun(val) {
      if (!val.isShow || !val.currentScheduleOperator && val.step == '0' && !val.operationAt) {
        return false;
      }
      console.log(val);
      this.$emit('go', val);
    }
  }
};